var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-edit-wrapper" }, [
    _c("input", {
      ref: "inputEdit",
      staticClass: "input-edit",
      class: _vm.r_input_class,
      attrs: {
        type: _vm.inputType,
        disabled: _vm.r_disabled,
        readonly: _vm.m_bReadOnly,
        placeholder: _vm.r_placeholder,
        pattern: _vm.pattern,
        maxlength: _vm.r_max_length,
        autocomplete: _vm.autocomplete
      },
      domProps: { value: _vm.m_inputdata },
      on: {
        input: function($event) {
          return _vm.updateValue(_vm.m_inputdata, $event)
        },
        keyup: _vm.onKeyup,
        blur: _vm.onBlur,
        focus: _vm.onFocus,
        change: _vm.onChange
      }
    }),
    _vm._v(" "),
    _vm.r_text_footer !== ""
      ? _c("div", { staticClass: "footer-text" }, [
          _vm._v("\r\n\t\t" + _vm._s(_vm.r_text_footer) + "\r\n\t")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      staticStyle: { display: "none" },
      attrs: { type: "text", name: "dummy" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58e14a05", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e14a05","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts_com/inputEdit.vue
// module id = 568
// module chunks = 0 1 2